import { render } from "./TipsModels.vue?vue&type=template&id=7e2e9048"
import script from "./TipsModels.vue?vue&type=script&lang=js"
export * from "./TipsModels.vue?vue&type=script&lang=js"
script.render = render

export default script